(function () {
  'use strict'
  const section = document.querySelector('[data-tdw]')
  if (!section) return
  const SOURCE = section.dataset.source || 'all'
  const LIMIT = Number(section.dataset.limit || 20)
  const ORDER = section.dataset.order || 'newest'
  const grid = section.querySelector('[data-tdw-grid]')
  const loading = section.querySelector('[data-tdw-loading]')
  const empty = section.querySelector('[data-tdw-empty]')

  // The whole catalogue is served alphabetically, so its window is the first 250 by
  // name: sorting those by date returns '47 Brand, adidas, Arizona as if they were new
  // arrivals. That is what showed on the home page. In "newest" mode nothing is
  // rendered from 'all'; a notice beats a new-arrivals shelf full of old catalogue.
  function typeKey (value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '')
      .replace(/s$/, '')
  }
  if (ORDER === 'newest' && (!SOURCE || SOURCE === 'all')) {
    loading.style.display = 'none'
    grid.style.display = 'none'
    empty.textContent = 'This section needs its own source collection.'
    empty.style.display = 'block'
    return
  }

  function moneyFormat (amount) {
    const parsed = parseFloat(amount)
    if (isNaN(parsed)) return amount
    return '$' + parsed.toFixed(2)
  }
  function discountPct (variant) {
    const price = parseFloat(variant.price)
    const compareAt = parseFloat(variant.compare_at_price)
    if (!compareAt || compareAt <= price) return 0
    return Math.round(((compareAt - price) / compareAt) * 100)
  }
  function escapeHtml (text) {
    if (text == null) return ''
    return String(text).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]
    })
  }

  function buildCard (product) {
    const variant = product.variants && product.variants[0]
    if (!variant) return null
    const img = product.images && product.images[0] ? product.images[0].src : ''
    const pct = discountPct(variant)
    const card = document.createElement('a')
    card.className = 'lo-tdw-card'
    card.href = '/products/' + product.handle
    card.setAttribute('data-product-type', (product.product_type || '').toLowerCase())
    card.setAttribute('data-product-tags', (product.tags || []).join(',').toLowerCase())
    card.setAttribute('data-discount', String(pct))
    card.innerHTML =
      '<div class="lo-tdw-card-img">' +
      (pct > 0 ? '<span class="lo-tdw-card-badge">-' + pct + '%</span>' : '') +
      (img
        ? '<img src="' + img + '" alt="' + escapeHtml(product.title) + '" loading="lazy"/>'
        : '') +
      '</div>' +
      (product.vendor
        ? '<div class="lo-tdw-card-team">' + escapeHtml(product.vendor) + '</div>'
        : '') +
      '<h3 class="lo-tdw-card-title">' +
      escapeHtml(product.title || '') +
      '</h3>' +
      '<div class="lo-tdw-card-price">' +
      '<span class="lo-tdw-card-price-now">' +
      moneyFormat(variant.price) +
      '</span>' +
      (parseFloat(variant.compare_at_price) > parseFloat(variant.price)
        ? '<span class="lo-tdw-card-price-was">' + moneyFormat(variant.compare_at_price) + '</span>'
        : '') +
      '</div>'
    return {
      el: card,
      discount: pct,
      date: product.published_at || '',
      kind: typeKey(product.product_type)
    }
  }

  // This used to ask for 50 products of a single collection, trim them to the LIMIT
  // with the deepest discount, and let the buttons hide cards from that window. With
  // 10 cards on screen and none of them a jersey, Jerseys said "no products match"
  // while the catalogue held hundreds. Each pill asks for its own collection now.
  const cache = {}

  function draw (cards) {
    loading.style.display = 'none'
    grid.innerHTML = ''
    if (!cards.length) {
      grid.style.display = 'none'
      empty.textContent = 'No products match this filter.'
      empty.style.display = 'block'
      return
    }
    cards.slice(0, LIMIT).forEach(function (card) {
      grid.appendChild(card.el.cloneNode(true))
    })
    grid.style.display = ''
    empty.style.display = 'none'
    markLoaded()
  }

  /*
     cloneNode does not copy listeners, so they are attached over the cards already
     placed.
  */
  function markLoaded () {
    grid.querySelectorAll('.lo-tdw-card-img img').forEach(function (img) {
      const box = img.parentNode
      if (img.complete && img.naturalWidth > 0) {
        box.classList.add('ready')
        return
      }
      img.addEventListener('load', function () {
        box.classList.add('ready')
      })
    })
  }

  // The catalogue does not serve the collection ordered by date and products.json
  // ignores sort_by, so the ordering happens here over the window that arrives. That
  // is why the window is 250: at 50 the newest thing reachable was already a month
  // old.
  function sortBy (cards) {
    if (ORDER === 'discount') {
      cards.sort(function (a, b) {
        return b.discount - a.discount
      })
    } else {
      cards.sort(function (a, b) {
        return a.date < b.date ? 1 : a.date > b.date ? -1 : 0
      })
    }
  }

  function fetchPage (handle) {
    if (cache[handle]) return Promise.resolve(cache[handle])
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250')
      .then(function (response) {
        return response.ok ? response.json() : { products: [] }
      })
      .then(function (data) {
        const cards = [];
        (data.products || []).forEach(function (product) {
          const card = buildCard(product)
          if (card) cards.push(card)
        })
        sortBy(cards)
        cache[handle] = cards
        return cards
      })
  }

  // The catalogue writes the type several ways (Hats, Hat, T-shirt, T-Shirts,
  // t-shirts), so they are compared by their key and not by the raw text.
  function filterBy (cards, kind) {
    const key = typeKey(kind)
    if (!key || key === 'all') return cards
    return cards.filter(function (card) {
      return card.kind === key
    })
  }

  function show (kind) {
    if (!cache[SOURCE]) {
      loading.style.display = ''
      grid.style.display = 'none'
      empty.style.display = 'none'
    }
    fetchPage(SOURCE)
      .then(function (cards) {
        draw(filterBy(cards, kind))
      })
      .catch(function () {
        loading.style.display = 'none'
        grid.style.display = 'none'
        empty.textContent = "Couldn't load products right now."
        empty.style.display = 'block'
      })
  }

  const buttons = section.querySelectorAll('[data-tdw-kind]')
  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      buttons.forEach(function (button) {
        button.classList.remove('is-active')
      })
      btn.classList.add('is-active')
      show(btn.dataset.tdwKind)
    })
  })

  function load () {
    const activeEl = section.querySelector('[data-tdw-kind].is-active')
    show(activeEl ? activeEl.dataset.tdwKind : '')
  }

  // They come to about 1 MB and the section is not visible when the home page opens:
  // it is requested as it approaches, so it does not compete for bandwidth with what
  // is already on screen.
  if ('IntersectionObserver' in window) {
    const watcher = new IntersectionObserver(
      function (entries) {
        if (
          entries.some(function (e) {
            return e.isIntersecting
          })
        ) {
          watcher.disconnect()
          load()
        }
      },
      { rootMargin: '400px' }
    )
    watcher.observe(section)
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load)
  } else {
    load()
  }
})()
